/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskQueuesIssueViewType from '@jira/spa-apps__servicedesk-queues-issue-view/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskQueuesIssueView: LazyComponent<typeof ServicedeskQueuesIssueViewType> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof ServicedeskQueuesIssueViewType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-queues-issue-view", jiraSpaEntry: "async-servicedesk-queues-issue-view" */ '@jira/spa-apps__servicedesk-queues-issue-view/src/index.tsx'
			),
		{
			ssr: false,
		},
	);
type Props = RouteContext;

/**
 * Constructs a URL path for navigating to a specific issue view within a service desk queue, incorporating optional parameters for issue identification and view customization.
 */

const AsyncServicedeskQueuesIssueView = ({ match }: Props): React.JSX.Element => {
	const issueKey = `/${(match.params && match.params.issueKey) || ''}`;
	const queueId = `/${(match.params && match.params.queueId) || ''}`;
	return (
		<LazyPage
			Page={LazyServicedeskQueuesIssueView}
			pageId={`spa-apps/servicedesk/queues/issue${queueId}${issueKey}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskQueuesIssueView;
